import { useTranslations } from "next-intl";
import { useSearchBox } from "react-instantsearch";
import ListingPageLink from "@components/views/Hub/ListingPageLink";
import { Slider } from "@components/core";
import CatalogBannerImage from "./CatalogBannerImage";
import CatalogBreadcrumb from "./CatalogBreadcrumb";
import CatalogHeaderStory from "./CatalogHeaderStory";

const CatalogHighlights = ({ hub, listingPage }) => {
  const t = useTranslations("catalog");

  const catalogType = listingPage ? "listingPage" : "hubPage";
  const breadcrumbs = listingPage?.breadcrumbs || [];
  const { query } = useSearchBox();
  const isMaternityListingPage = listingPage?.slug === "maternity";

  function findPageData() {
    switch (catalogType) {
      case "hubPage":
        return {
          mobilePictureSource: hub?.mobile_picture_url,
          desktopPictureSource: hub?.desktop_picture_url,
          shortDescription: hub?.short_description,
        };
      case "listingPage":
        return {
          mobilePictureSource: listingPage?.hub_image_url,
          desktopPictureSource: listingPage?.image_url,
          shortDescription: listingPage?.short_description,
        };
      default:
        return {};
    }
  }

  const { mobilePictureSource, desktopPictureSource, shortDescription } = findPageData(catalogType);

  function pageLinksList() {
    return hub?.listing_pages?.map((hubListingPage, index) => (
      <div
        className="listing-page-link-container"
        key={`listing-page-${hubListingPage.id}`}
      >
        <ListingPageLink
          hubSlug={hub?.slug}
          {...hubListingPage}
          sliderPosition={index + 1}
        />
      </div>
    ));
  }

  function displayTitle() {
    if (query) return t("highlights.query_title", { query });
    if (catalogType === "listingPage") return listingPage?.title;

    return hub?.title;
  }

  const hubWithListingPageHubImageUrl = hub?.listing_pages?.some(
    (hubListingPage) => hubListingPage.hub_image_url,
  );

  return (
    <div>
      {isMaternityListingPage ? (
        <CatalogHeaderStory />
      ) : (
        <CatalogBannerImage
          title={hub?.title || listingPage?.carousel_title}
          mobilePictureSource={mobilePictureSource}
          desktopPictureSource={desktopPictureSource}
        />
      )}
      <div className="d-flex flex-column align-items-center mx-2">
        <div className="d-flex flex-column catalog-highlights-container">
          <CatalogBreadcrumb breadcrumbs={hub ? [hub] : breadcrumbs} />
          <h1 className="h2 text-center mb-0">{displayTitle()}</h1>
          {shortDescription && (
            <p className="mb-1 catalog-short-description text-gray font-size-sm">
              {shortDescription}
            </p>
          )}
        </div>
      </div>
      {hubWithListingPageHubImageUrl && !query && (
        <section className="container">
          <Slider
            name="catalog-highlights"
            cards={pageLinksList()}
            sliderBreakingPoint={768}
          />
        </section>
      )}
    </div>
  );
};

export default CatalogHighlights;
